/**
 * ADR 0048 — a identificação PERMANENTE do ambiente de demonstração. Fora do React e antes de tudo: aparece na
 * entrada, na ativação, no Campo e em todo cockpit, e não some com nenhuma navegação.
 *
 * Duas fontes, e basta uma: o build (`VITE_ATALAIA_AMBIENTE=DEMONSTRACAO`, o endereço demo) e a verdade do servidor
 * (`tenantNatureza` da sessão). Se o build disser OPERACIONAL e a sessão for de um tenant de demonstração (ou o
 * contrário), a faixa diz isso — a pessoa nunca confunde demonstração com a operação.
 */

const env = import.meta.env as Record<string, string | undefined>;
export const AMBIENTE_DO_BUILD: 'DEMONSTRACAO' | 'OPERACIONAL' | null =
  env['VITE_ATALAIA_AMBIENTE'] === 'DEMONSTRACAO' ? 'DEMONSTRACAO' : env['VITE_ATALAIA_AMBIENTE'] === 'OPERACIONAL' ? 'OPERACIONAL' : null;

export function marcarAmbiente(naturezaDaSessao?: string | null): void {
  const demo = AMBIENTE_DO_BUILD === 'DEMONSTRACAO' || naturezaDaSessao === 'DEMONSTRACAO';
  const divergente = AMBIENTE_DO_BUILD === 'OPERACIONAL' && naturezaDaSessao === 'DEMONSTRACAO';
  document.documentElement.dataset['ambiente'] = demo ? 'demonstracao' : naturezaDaSessao === 'OPERACIONAL' || AMBIENTE_DO_BUILD === 'OPERACIONAL' ? 'operacional' : 'desconhecido';
  let faixa = document.getElementById('faixa-ambiente');
  if (!demo) { faixa?.remove(); return; }
  if (!document.title.startsWith('[DEMO] ')) document.title = `[DEMO] ${document.title}`;
  if (!faixa) {
    faixa = document.createElement('div');
    faixa.id = 'faixa-ambiente';
    faixa.setAttribute('role', 'note');
    document.body.prepend(faixa);
  }
  faixa.textContent = divergente
    ? 'ATENÇÃO: esta sessão é de um tenant de DEMONSTRAÇÃO num endereço operacional — saia e entre pelo endereço certo'
    : 'DEMONSTRAÇÃO · dados sintéticos — não é a operação real';
}
